import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { NumericFormat } from '@blade/std-lib'
import { Tooltip } from '@blade/ui-kit'
import { PairAudit, type PairModel } from '@root/entities/pair'
import { PairLink } from '@root/entities/pair/ui/common'
import { CircleCheckMarkIcon, CircleErrorIcon } from '@root/shared/ui-kit/icons'

type Props = {
  pair: PairModel
}

export const ExploreTableAuditCell: React.FC<Props> = ({ pair }) => {
  const [audit] = useAtom(pair.audit)

  const cv = PairAudit.isSafe(audit.checks.isMintable)
  const cr = PairAudit.isSafe(audit.checks.isFreezable)
  // UI check for LP Burned, requested by BE
  const lpBurned = audit.checks.lpBurned.percent >= 80
  const t10 = PairAudit.isSafe(audit.checks.top10HoldersPercentage)

  const { t } = useTranslation()

  return (
    <Root>
      <Tooltip content={t('table.audit.cv')}>
        <AuditCheckItem pair={pair}>
          <AuditCheckIcon active={cv} />
        </AuditCheckItem>
      </Tooltip>
      <Tooltip content={t('table.audit.cr')}>
        <AuditCheckItem pair={pair}>
          <AuditCheckIcon active={cr} />
        </AuditCheckItem>
      </Tooltip>
      <Tooltip
        content={t('table.audit.nhp', {
          percentage: NumericFormat.formatPreset(
            audit.checks.lpBurned.percent,
            'percents',
          ),
        })}
      >
        <AuditCheckItem pair={pair}>
          <AuditCheckIcon active={lpBurned} />
        </AuditCheckItem>
      </Tooltip>
      <Tooltip
        content={t('table.audit.t10', {
          percentage: NumericFormat.formatPreset(
            audit.checks.top10HoldersPercentage.percent,
            'percents',
          ),
        })}
      >
        <AuditCheckItem pair={pair}>
          <AuditCheckIcon active={t10} />
        </AuditCheckItem>
      </Tooltip>
    </Root>
  )
}

const AuditCheckIcon = ({ active, ...rest }: { active: boolean }) => {
  if (active) {
    return <CircleCheckMarkIcon {...rest} size={16} color="var(--success-9)" />
  }
  return <CircleErrorIcon {...rest} size={16} color="var(--error-9)" />
}
const AuditCheckItem = styled(PairLink<PairModel>)`
  pointer-events: auto;
`
const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  font-size: 6px;
`
